import { Pipe, PipeTransform } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Pipe({
  name: 'filterForm',
  pure: false
})
export class FilterFormPipe implements PipeTransform {
  
  transform(values: any[], filterForm: FormGroup, properties: any[]): any[] {
    if (!values || !values.length) {
      return [];
    }
    if (!filterForm) {
      return values;
    }
    return values.filter((value: any) => {
      let foundValue = true;
      for (const property of properties) {
        if (!filterForm.get(property.formKey)?.value) {
          continue;
        }
        const formValue = filterForm.get(property.formKey)?.value;
        if (property.queryType === 'array') {
          const valuesRaw = this.getNestedValue(value, property.valueKey);
          const valuesArray = Array.isArray(valuesRaw) ? valuesRaw : [valuesRaw].filter(v => v !== undefined && v !== null);
          foundValue = formValue.some((x: any) => valuesArray.some((y: any) => y === x));
          if (foundValue) {
            continue;
          }
          break;
        }
        if (property.queryType === 'like') {
          const nestedVal = this.getNestedValue(value, property.valueKey);
          foundValue = nestedVal.toLowerCase().includes(formValue.toLowerCase());
          if (foundValue) {
            continue;
          }
          break;
        }
        foundValue = value[property.valueKey] === filterForm.get(property.formKey)?.value;
      }
      return foundValue;
    });
  }
  
  private getNestedValue = (obj: any, path: string) => {
    return path.split('.').reduce((acc, key) => acc && acc[key], obj);
  };
  
}
